module.exports = __webpack_public_path__ + "img/interior_4.5.94ae2141.jpg";